import { useEffect, useRef, useState } from "react";
import { useTranslation } from "next-i18next";
import { cn } from "../../../../../lib/utils";

const ASSETS_PATH = "/landings/assets/images/products/hub-talentos";

const ATIVIDADE_ITEMS = [
	{ key: "desenvolvimento", icon: "icon-code.svg" },
	{ key: "testesQualidade", icon: "icon-magnifying.svg" },
	{ key: "documentacao", icon: "icon-filecode.svg" },
	{ key: "planejamentoTecnico", icon: "icon-listchecks.svg" },
	{ key: "analiseProblemas", icon: "icon-bug.svg" },
];

export default function AtividadesSection() {
	const { t } = useTranslation();
	const scrollRef = useRef(null);
	const [thumb, setThumb] = useState({ width: 100, left: 0, visible: false });

	const updateThumb = () => {
		const el = scrollRef.current;
		if (!el) return;
		const { scrollLeft, scrollWidth, clientWidth } = el;
		if (scrollWidth <= clientWidth) {
			setThumb((prev) => ({ ...prev, visible: false }));
			return;
		}
		const ratio = clientWidth / scrollWidth;
		const width = Math.max(20, ratio * 100);
		const left = (scrollLeft / (scrollWidth - clientWidth)) * (100 - width);
		setThumb({ width, left, visible: true });
	};

	useEffect(() => {
		updateThumb();
		const onResize = () => updateThumb();
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	return (
		<section className="bg-neutral-08">
			<div className="container-blog">
			<div
				ref={scrollRef}
				onScroll={updateThumb}
				className="overflow-x-auto tablet:overflow-x-visible scrollbar-none"
			>
				<div className="border border-ds-brand-green-300 rounded-2xl overflow-hidden min-w-[640px] tablet:min-w-0">
					{/* Header */}
					<div className="flex bg-vivid-02">
						<div className="w-[228px] laptop:w-[287px] px-6 py-3 shrink-0">
							<span className="!text-ds-brand-green-1000 font-bold text-base laptop:text-xl uppercase leading-6 laptop:leading-8">
								{t("products.hub-talentos.atividades.headerAtividade")}
							</span>
						</div>
						<div className="flex-1 px-2 laptop:px-6 py-3">
							<span className="!text-ds-brand-green-1000 font-bold text-base laptop:text-xl uppercase leading-6 laptop:leading-8">
								{t("products.hub-talentos.atividades.headerIA")}
							</span>
						</div>
					</div>

					{/* Body */}
					{ATIVIDADE_ITEMS.map((item, index) => (
						<div
							key={item.key}
							className={cn(
								index > 0 && "border-t border-vivid-02",
								"flex items-center"
							)}
						>
							<div className="flex items-center gap-2 w-[228px] laptop:w-[25%] laptopM:w-[287px] pl-6 pr-4 py-2 laptop:py-5 shrink-0">
								<span className="!text-vivid-02 font-semibold text-sm laptop:text-lg leading-7 tablet:leading-8">
									{t(`products.hub-talentos.atividades.items.${item.key}.name`)}
								</span>
								<div className="w-8 h-8 flex items-center justify-center shrink-0">
									<img
										src={`${ASSETS_PATH}/${item.icon}`}
										alt=""
										className="w-auto h-auto max-w-full max-h-full"
									/>
								</div>
							</div>
							<div className="flex-1 px-2 laptop:px-6 py-2 laptop:py-5">
								<span className="!text-white text-sm laptop:text-lg leading-6 tablet:leading-8 tablet:whitespace-nowrap laptop:whitespace-normal">
									{t(`products.hub-talentos.atividades.items.${item.key}.description`)}
								</span>
							</div>
						</div>
					))}
				</div>
			</div>

			{/* Custom scrollbar (mobile only) */}
			{thumb.visible && (
				<div className="tablet:hidden mx-auto mt-4 relative w-[200px] h-2 rounded-full bg-[#4b5563]">
					<div
						className="absolute top-0 h-full rounded-full bg-ds-brand-green-400 transition-[left,width] duration-75"
						style={{ width: `${thumb.width}%`, left: `${thumb.left}%` }}
					/>
				</div>
			)}
			</div>
		</section>
	);
}
